import React from 'react';
import { Link } from 'react-router-dom';

export const DISPLAY = "'Space Grotesk', sans-serif";
export const BODY = "'Plus Jakarta Sans', sans-serif";
export const MONO = "'JetBrains Mono', monospace";

export function Brand({ light = true }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-brand-logo">
      <img src="/logo-mark-256.png" alt="NikoSafe Training" className="w-10 h-10 object-contain drop-shadow-[0_0_12px_rgba(6,182,212,0.45)] group-hover:scale-105 transition-transform" />
      <div className="leading-tight"><div className={`font-bold text-lg ${light ? 'text-slate-100' : 'text-slate-900'}`} style={{ fontFamily: DISPLAY }}>NikoSafe Training</div><div className="text-[10px] uppercase tracking-[0.2em] text-cyan-400" style={{ fontFamily: MONO }}>A NikoSafe product</div></div>
    </Link>
  );
}

export function StatusBadge({ className = '' }) {
  return (
    <div className={`inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full bg-cyan-950/60 border border-cyan-500/30 text-cyan-300 shadow-[0_0_15px_rgba(6,182,212,0.15)] ${className}`} data-testid="status-badge-invite-only">
      <span className="relative flex h-2 w-2"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" /><span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" /></span>
      <span className="text-[11px] sm:text-xs uppercase tracking-[0.18em]" style={{ fontFamily: MONO }}>By invite only · Coming soon for commercial use</span>
    </div>
  );
}

export function GoogleIcon({ className = 'w-5 h-5' }) {
  return (
    <svg className={className} viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
    </svg>
  );
}

export function SectionHeading({ eyebrow, title, lead, align = 'left' }) {
  return (
    <div className={align === 'center' ? 'text-center mx-auto max-w-3xl' : 'max-w-3xl'}>
      {eyebrow && <div className="text-xs uppercase tracking-[0.2em] text-cyan-400 mb-3" style={{ fontFamily: MONO }}>{eyebrow}</div>}
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-100" style={{ fontFamily: DISPLAY }}>{title}</h2>
      {lead && <p className="mt-4 text-base sm:text-lg text-slate-400 leading-relaxed">{lead}</p>}
    </div>
  );
}

export const fadeUp = { initial: { opacity: 0, y: 24 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: '-60px' }, transition: { duration: 0.55, ease: 'easeOut' } };
